<button (click) ="pay()">Pay</button>

<form #form ngNoForm 
      id="nonseamless" 
      method="post"
      name="redirect" 
      [action]=url>
      <!-- https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction -->
  <input type="hidden" id="encRequest" name="encRequest" [ngModel]="encRequest">
  <input type="hidden" name="access_code" id="access_code" [ngModel]="accessCode">
</form>
